import React from 'react'
import { Link } from 'react-router-dom'
const index = () => {
  return (
    <div className='max-w-[564.96px] mx-auto flex flex-col items-center justify-center pt-[160px] px-5 xl:px-0'>
      <h1 className='font-semibold text-[27px] md:text-[42px] leading-9 md:leading-[48px]'>Lost in Cyberspace?</h1>
      <p className='text-base md:text-lg leading-6 md:leading-[30px] opacity-[0.88] mt-2.5 md:my-3 text-center'>
        The page you are looking for does not seem to exist.
      </p>
      <Link className='flex items-center space-x-[13.5px] mt-2 md:mt-0' to={'/'}>
        <p className='text-lg md:text-xl text-themeOrange font-medium'>Go to Homepage</p>
      </Link>
    </div>
  )
}

export default index
